Ext.define('SA.data.DatasetFactory', {
    constructor({currentYear}) {
        this.currentYear = currentYear;
    },

    create({countryCode, vendorName, id, name, premium, editions, latestGeographicRelease, latestEditionInLatestCensusRelease, hasFolders}) {
        var censusReleases = this.createCensusReleases({latestEditionInLatestCensusRelease, editions});

        return new SA.model.Dataset({id, name, premium, latestGeographicRelease, censusReleases, countryCode, vendorName, hasFolders});
    },

    createCensusReleases({latestEditionInLatestCensusRelease, editions}) {
        var entries = Object.entries(editions).map(entry => [Number(entry[0]), entry[1]]),
            censusReleasesYears = entries.map(entry => entry[0]),
            latestCensusReleaseYear = Math.max(...censusReleasesYears),
            isLatestCensusReleaseYear = censusReleaseYear => censusReleaseYear === latestCensusReleaseYear,
            getLatestNonProjection = years => Math.max(...years.filter(year => year <= this.currentYear)),
            getLatestEdition = ({censusReleaseYear, editions}) => isLatestCensusReleaseYear(censusReleaseYear) ? latestEditionInLatestCensusRelease : getLatestNonProjection(editions),
            censusReleaseEntries = entries.map(([censusReleaseYear, editions]) => {
                var latestEdition = getLatestEdition({censusReleaseYear, editions}),
                    censusRelease = new SA.model.DatasetCensusRelease({censusReleaseYear, latestEdition, editions});

                return [censusReleaseYear, censusRelease];
            }),
            censusReleases = Object.fromEntries(censusReleaseEntries);

        return new SA.model.DatasetCensusReleases({censusReleases});
    }
});